import { useState } from "react";
import axios from "axios";
import { API, setToken, formatApiError } from "../lib/api";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.token);
      onSuccess();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-bone flex items-center justify-center px-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-cream border border-ink/10 rounded-2xl p-8 space-y-5 shadow-sm"
      >
        <div className="space-y-1">
          <p className="text-xs uppercase tracking-[0.16em] text-cognac font-semibold">Area Riservata</p>
          <h1 className="font-display text-2xl font-semibold text-ink">Gestione Vetrina</h1>
        </div>
        <div className="space-y-2">
          <label htmlFor="admin-email" className="text-xs font-medium text-ink/70 uppercase tracking-wider">
            Email
          </label>
          <input
            id="admin-email"
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-ink/15 bg-white px-4 py-2.5 text-sm text-ink focus:outline-none focus:border-cognac"
            autoComplete="username"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="admin-password" className="text-xs font-medium text-ink/70 uppercase tracking-wider">
            Password
          </label>
          <input
            id="admin-password"
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-ink/15 bg-white px-4 py-2.5 text-sm text-ink focus:outline-none focus:border-cognac"
            autoComplete="current-password"
          />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {error}
          </p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="w-full bg-ink text-bone rounded-full py-3 text-sm uppercase tracking-[0.14em] font-medium hover:bg-cognac transition-colors disabled:opacity-50"
        >
          {loading ? "Accesso..." : "Accedi"}
        </button>
        <a href="/" data-testid="admin-back-home" className="block text-center text-xs text-ink/60 hover:text-cognac transition-colors">
          &larr; Torna al sito
        </a>
      </form>
    </div>
  );
};
